import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-368e732a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  colspan: "3",
  rowspan: "7"
}
const _hoisted_2 = { class: "resTable" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Summe"),
  /*#__PURE__*/_createElementVNode("th", null, "Ø")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Import/ Export (Nur Qualifikation Block 1)", -1))
const _hoisted_5 = ["href", "download"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "exportBTN" }, "Exportieren", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "exportBTN" }, [
  /*#__PURE__*/_createElementVNode("label", { for: "exportBTN" }, "Importieren")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("th", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tr", null, [
        _createElementVNode("th", null, _toDisplayString(_ctx.gesamtpunktzahl), 1),
        _createElementVNode("th", null, _toDisplayString(_ctx.abiDurchschnitt), 1)
      ])
    ]),
    _hoisted_4,
    _createElementVNode("a", {
      href: _ctx.exportToFile,
      download: `Abischnitt-Rechner-Export.json`
    }, _hoisted_7, 8, _hoisted_5),
    _createElementVNode("input", {
      id: "exportBTN",
      name: "exportBTN",
      class: "exportBTN",
      type: "file",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
      title: "Importieren"
    }, null, 32),
    _hoisted_8
  ]))
}